// @ts-nocheck
/* eslint-enable */
// App
import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import FocusLock from 'react-focus-lock';

// Misc / utils
import appUtils from 'app/shared/utils/appUtils';
import * as S from './styles';

const FilterButtonFullPageDropdown = ({ ariaLabel, header, children, dropdownId, onClose }) => {
  // React refs
  const buttonRef = useRef(null);
  const fixedHeaderRef = useRef(null);

  // React state
  const [fixedHeaderHeight, setFixedHeaderHeight] = useState(null);

  useEffect(() => {
    appUtils.lockVerticalScrolling({ isForPortal: true });
    if (buttonRef.current) {
      buttonRef.current.focus();
    }

    return () => {
      appUtils.unlockVerticalScrolling();
    };
  }, []);

  useEffect(() => {
    if (fixedHeaderRef.current) {
      setFixedHeaderHeight(fixedHeaderRef.current.offsetHeight);
    }
  }, [header]);

  // Esc key will close filter modal
  const handleOnKeyDown = (e) => {
    return e.keyCode === 27 && onClose();
  };

  return ReactDOM.createPortal(
    <S.Overlay
      id={dropdownId}
      role="dialog"
      aria-label={ariaLabel}
      aria-modal="true"
      tabIndex="-1"
      onKeyDown={handleOnKeyDown}
    >
      <FocusLock>
        <S.Header ref={fixedHeaderRef}>
          <S.ButtonSection>
            <S.Button onClick={onClose} aria-label="Close modal" ref={buttonRef}>
              Done
            </S.Button>
          </S.ButtonSection>
          <S.Section>{header}</S.Section>
        </S.Header>
        <S.Article paddingTop={fixedHeaderHeight}>{children}</S.Article>
      </FocusLock>
    </S.Overlay>,
    document.body,
  );
};

export default FilterButtonFullPageDropdown;
